import * as React from "react"
import HTMLReactParser from 'html-react-parser';
import { Container } from 'react-bootstrap';
import ModalTiny from "react-bootstrap/Modal"
import ImageTransform from "../../common/ggfx-client/module/components/image-transform";
import { GetURL } from "../../common/site/functions";
import { Link } from "@StarberryUtils";
import { CloseIcon } from "../../Icons/Icons";
import "./StaticBanner.scss";
import ImageModule from "../../common/Image_Module";
import BookAViewForm from "../../forms/book-a-viewing-form";
import ValuationFormPage from "../../forms/valuation-form";
import CareerForm from "../../forms/career-form";
import MortgageForm from "../../forms/mortgage-form";

const StaticBanner = (props) => {

	const image_url = props.image.url

	let processedImages = JSON.stringify({});
	if (props.imagetransforms?.Banner_Image_Transforms) {
		processedImages = props.imagetransforms?.Banner_Image_Transforms;
	}
	const [modalBookViewformOpen, setBookViewingformOpen] = React.useState(false);
	const openBookViewformModal = () => {
	  setBookViewingformOpen(true);
	}
	const closeBookViewformModal = () => {
	  setBookViewingformOpen(false);
	}
  
	const [modalValuationformOpen, setValuationformOpen] = React.useState(false);
	const openValuationformModal = () => {
	  setValuationformOpen(true);
	}
	const closeValuationformModal = () => {
	  setValuationformOpen(false);
	}
	
    const [modalApplyformOpen, setApplyformOpen] = React.useState(false);

	const openApplyformModal = () => {
		setApplyformOpen(true);
	}
	const closeApplyformModal = () => {
		setApplyformOpen(false);
	}

	const [modalMortgageForm, setMortgageForm] = React.useState(false);

	const openMortgageFormModal = () => {
		setMortgageForm(true);
	}
	const closeMortgageFormModal = () => {
		setMortgageForm(false);
	}

	return (
		<div className="static-top-banner">
			<div className="image">
				{/* <ImageTransform 
				imagesources={image_url} 
				renderer="srcSet" 
				imagename="articles.Banner_Image.full_details" 
				attr={{ alt: `${props.image.alternativeText} - Dacha`, 
				class: '' }} 
				imagetransformresult={processedImages} 
				id={props.id} /> */}
				<ImageModule 
						ImageSrc={props?.image } 
						attr={{ alt: props.image.alternativeText + ' - Dacha', class: '' }} 
						ggfx_results={props?.ggfx_results} 
						imagename="articles.Banner_Image.full_details"
						strapi_id={props?.id} 
				/>    
			</div>
			<div className="static-page-banner-content">
				<Container>
						<div className="content">
							{props.title &&
								<h1>{props.title}</h1>
							}
							{props.content &&
								<div className="banner-intro-text">
									{HTMLReactParser(props.content.replace(/\n/g, ''))}
								</div>
							}
							<div className={`${props?.mobile_sticky ? 'd-none d-md-flex' : 'd-flex'} btn-wrapper`}>							
								{props.cta_1 && props.search === "Book_Appointment" &&  !props.cta_1_link &&
									<button className="btn btn-primary contact-book-btn" onClick={openBookViewformModal}>{props.cta_1}</button>
								}
								{props.cta_1 && props.search === "Valuation_Form" &&
									<button className="btn btn-primary contact-book-btn" onClick={openValuationformModal}>{props.cta_1}</button>
								}
								{props.cta_1 && props.search === "Send_CV" &&
									<button className="btn btn-primary contact-book-btn" onClick={openApplyformModal}>{props.cta_1}</button>
								}
								{props.cta_1 && props.search === "Mortgage_Form" &&
									<button className="btn btn-primary contact-book-btn" onClick={openMortgageFormModal}>{props.cta_1}</button>
								}
								{props.cta_1 && props.cta_1_link &&
									<Link to={`/${GetURL(props.cta_1_link.id)}`} className="btn btn-primary">{props?.cta_1} </Link>
								}
								{props.cta_2 && props.cta_2_link &&
									<Link to={`/${GetURL(props.cta_2_link.id)}`} className="btn btn-secondary">{props?.cta_2} </Link>
								}
							</div>
						</div>
				 </Container>
			</div>		
			<ModalTiny show={modalBookViewformOpen} onHide={closeBookViewformModal} className="modal-form-wrapper form-viewing-wrapper">
				<ModalTiny.Header>
				<div class="modal-close-btn" onClick={closeBookViewformModal}><CloseIcon /></div>
				<ModalTiny.Title>
					<h4>Book an Appointment</h4>
				</ModalTiny.Title>
				</ModalTiny.Header>
				<ModalTiny.Body>
				<BookAViewForm
					property_img={``}
					property_id={''}
					page_url={null}
					property_title={''}
					negotiator={''} />
				</ModalTiny.Body>
			</ModalTiny>    
			<ModalTiny show={modalValuationformOpen} onHide={closeValuationformModal} className="modal-form-wrapper form-valuation-wrapper">      
				<ModalTiny.Header>  
				<div class="modal-close-btn" onClick={closeValuationformModal}><CloseIcon /></div>        
				<ModalTiny.Title>
					<h4>Property Valuation</h4>
					<p className="text-sm">Receive a Professional Property Valuation in Minutes – Just Fill Out the Form</p> 
				</ModalTiny.Title>
				</ModalTiny.Header>
				<ModalTiny.Body>
				<ValuationFormPage />
				</ModalTiny.Body>				
			</ModalTiny>
			<ModalTiny show={modalApplyformOpen} onHide={closeApplyformModal} className="modal-form-wrapper people-details-form-modal">
                <ModalTiny.Header>
                <div class="modal-close-btn" onClick={closeApplyformModal}><CloseIcon /></div>
                    <ModalTiny.Title><h4>Send your CV</h4></ModalTiny.Title>
                </ModalTiny.Header>
                <ModalTiny.Body>
                    <CareerForm />
                </ModalTiny.Body>
            </ModalTiny>
			<ModalTiny show={modalMortgageForm} onHide={closeMortgageFormModal} className="modal-form-wrapper people-details-form-modal">
                <ModalTiny.Header>
                <div class="modal-close-btn" onClick={closeMortgageFormModal}><CloseIcon /></div>
                    <ModalTiny.Title><h4>Mortgage Consulting</h4></ModalTiny.Title>
                </ModalTiny.Header>
                <ModalTiny.Body>
                    <MortgageForm />
                </ModalTiny.Body>
            </ModalTiny>
		</div>
	)
}

export default StaticBanner